// extracted by mini-css-extract-plugin
export var block = "custom-block-module--block--agv9T";
export var customBlock = "custom-block-module--customBlock--T99yK";
export var highlighted = "custom-block-module--highlighted--N8tmM";
export var image = "custom-block-module--image--P3fs1";
export var infoTrafficBlock = "custom-block-module--infoTrafficBlock--LhY+e";
export var link = "custom-block-module--link--DqXO7";
export var linkTraffic = "custom-block-module--linkTraffic--H0CWk";
export var myContainer = "custom-block-module--myContainer--G-xvS";
export var selectedButton = "custom-block-module--selectedButton--Vm+Ta";
export var svgImage = "custom-block-module--svgImage--5WtCX";
export var tabButtonsContainer = "custom-block-module--tabButtonsContainer--pbLqX";
export var title = "custom-block-module--title--6AwSP";
export var unselectedButton = "custom-block-module--unselectedButton--NJU4C";